export default function(controller) {
  if (!controller.resultsShown) return;

  controller.close();
  controller.resultsTarget.innerHTML = null;
}
